import type { LucideIcon } from 'lucide-react';
import { CalendarDays, CreditCard, FileText, HeartPulse, Home, MessageSquare, UserRound } from 'lucide-react';

/**
 * Patient-portal nav (issue #154). Home is live now; the feature tabs are
 * placeholders wired to their routes and filled by the sibling issues noted in
 * `issue`. Deliberately carries NO clinician surfaces.
 */
export interface PortalNavItem {
  id: string;
  label: string;
  to: string;
  icon: LucideIcon;
  /** The feature issue that will fill this tab (undefined = shipped now). */
  issue?: number;
}

export const portalNavItems: PortalNavItem[] = [
  { id: 'home', label: 'Home', to: '/portal', icon: Home },
  { id: 'appointments', label: 'Appointments', to: '/portal/appointments', icon: CalendarDays },
  { id: 'messages', label: 'Messages', to: '/portal/messages', icon: MessageSquare },
  { id: 'profile', label: 'Intake & Profile', to: '/portal/profile', icon: UserRound },
  { id: 'health', label: 'Health', to: '/portal/health', icon: HeartPulse },
  { id: 'documents', label: 'Documents', to: '/portal/documents', icon: FileText },
  { id: 'billing', label: 'Billing', to: '/portal/billing', icon: CreditCard, issue: 160 },
];

/**
 * A tab is LIVE once its owning feature has shipped — signalled by the absence of a
 * pending `issue`. This is the single source of truth for "available vs coming
 * soon" across the portal (nav + home dashboard); a sibling feature goes live by
 * dropping its `issue` here, with no other edit needed.
 */
export function isPortalTabActive(item: PortalNavItem): boolean {
  return item.issue === undefined;
}
